module.exports = __webpack_public_path__ + "static/media/hubspot-white.3e560266.svg";